module.exports = __webpack_public_path__ + "img/Bank Sumut.1d7da400.png";